/**
 * FloatingActionButton — extracted from DriverView.js
 *
 * Expanding FAB (mobile-style speed-dial) with three actions:
 *   • Send Files (photo)
 *   • Call Dispatch (call)
 *   • Quick POD (pod)
 *
 * Pure presentational. Parent owns the `onAction` callback.
 * The `isTracking` prop is reserved for future visual cues (e.g. green dot
 * when location tracking is active) — kept on the public surface to avoid
 * breaking calling code.
 */
import React, { useState } from 'react';
import { Paperclip, Phone, ClipboardCheck, Plus } from 'lucide-react';

const ACTIONS = [
  { icon: Paperclip, label: 'Send Files', action: 'photo', color: 'bg-purple-600' },
  { icon: Phone, label: 'Call Dispatch', action: 'call', color: 'bg-blue-600' },
  { icon: ClipboardCheck, label: 'Quick POD', action: 'pod', color: 'bg-green-600' },
];

// eslint-disable-next-line no-unused-vars
export const FloatingActionButton = ({ onAction, isTracking }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="fixed bottom-20 right-4 z-40" data-testid="fab-container">
      {/* Action buttons */}
      <div className={`flex flex-col-reverse gap-3 mb-3 transition-all duration-300 ${isOpen ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4 pointer-events-none'}`}>
        {ACTIONS.map((a, index) => (
          <button
            key={a.action}
            onClick={() => { onAction(a.action); setIsOpen(false); }}
            className={`${a.color} w-12 h-12 rounded-full flex items-center justify-center shadow-lg hover:scale-110 transition-transform`}
            style={{ transitionDelay: isOpen ? `${index * 50}ms` : '0ms' }}
            data-testid={`fab-action-${a.action}`}
            aria-label={a.label}
          >
            <a.icon className="h-5 w-5 text-white" />
          </button>
        ))}
      </div>

      {/* Main FAB */}
      <button
        onClick={() => setIsOpen((open) => !open)}
        className={`w-14 h-14 rounded-full flex items-center justify-center shadow-xl transition-all duration-300 ${
          isOpen ? 'bg-slate-700 rotate-45' : 'bg-amber-600 hover:bg-amber-500'
        }`}
        data-testid="fab-main"
        aria-expanded={isOpen}
        aria-label="Open quick actions"
      >
        <Plus className="h-6 w-6 text-white" />
      </button>
    </div>
  );
};
